import React from 'react';
import { TOTAL_STEPS } from './constants';

const WizardProgressBar = React.memo(function WizardProgressBar({
  currentStep,
  onStepClick,
}) {
  return (
    <div className="wizard__progress-bar">
      {Array.from({ length: TOTAL_STEPS }, (_, i) => {
        const stepNum = i + 1;
        const isCompleted = stepNum < currentStep;
        const isCurrent = stepNum === currentStep;
        return (
          <div
            key={stepNum}
            className={
              'wizard__progress-segment' +
              (isCompleted ? ' wizard__progress-segment--completed' : '') +
              (isCurrent ? ' wizard__progress-segment--current' : '') +
              (isCompleted ? ' wizard__progress-segment--clickable' : '')
            }
            onClick={isCompleted ? () => onStepClick(stepNum) : undefined}
            role={isCompleted ? 'button' : undefined}
            tabIndex={isCompleted ? 0 : undefined}
            onKeyDown={
              isCompleted
                ? (e) => {
                    if (e.key === 'Enter' || e.key === ' ') onStepClick(stepNum);
                  }
                : undefined
            }
          />
        );
      })}
    </div>
  );
});

export default WizardProgressBar;
